import { string, func } from 'prop-types';
import {
  COLOR_MAP_ROUTE,
  COLOR_MAP_CUSTOM_ROUTE_1,
  COLOR_MAP_CUSTOM_ROUTE_2,
  COLOR_MAP_CUSTOM_ROUTE_3,
  COLOR_MAP_CUSTOM_ROUTE_4
} from '@alltrails/shared/denali/tokens';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './styles/styles.module.scss';

const colors = [COLOR_MAP_ROUTE, COLOR_MAP_CUSTOM_ROUTE_1, COLOR_MAP_CUSTOM_ROUTE_2, COLOR_MAP_CUSTOM_ROUTE_3, COLOR_MAP_CUSTOM_ROUTE_4];
export const DEFAULT_ROUTE_COLOR = colors[0];

const RouteColorRadioButtons = ({ onChange, activeColor = DEFAULT_ROUTE_COLOR }) => {
  const radioButtons = colors.map((color, index) => {
    const id = `${color}-color`.replace('#', '');

    return (
      <div className={styles.container} key={id}>
        <input
          aria-label={id}
          className={styles.radiobutton}
          value={color}
          onChange={onChange}
          id={id}
          type="radio"
          checked={activeColor === color}
        />
        <label htmlFor={id} style={{ backgroundColor: color }}>
          <span className={styles.screenReadersOnly}>
            <FormattedMessage defaultMessage="Color {order}" values={{ order: index + 1 }} />
          </span>
        </label>
      </div>
    );
  });

  return <div className={styles.formContainer}>{radioButtons}</div>;
};

RouteColorRadioButtons.propTypes = {
  onChange: func.isRequired,
  activeColor: string
};

export default RouteColorRadioButtons;
